export default [
  {
    additionalAttributes: {
      city: 'São Paulo',
      country: 'Brasil',
      description:
        'Sou Lucas, um desenvolvedor focado em soluções web. Atualmente, trabalho como Desenvolvedor de Produto na Sendd.',
      companyName: 'Sendd',
      countryCode: 'BR',
      socialProfiles: {
        github: 'lucas-dev',
        twitter: 'lucas_w_dev',
        facebook: 'lucas.dev',
        linkedin: 'lucas-silva',
        instagram: 'lucas.codes',
      },
    },
    availabilityStatus: 'offline',
    email: 'lucas.silva@sendd.com',
    id: 22,
    name: 'Lucas Silva',
    companyName: 'Sendd',
    phoneNumber: '+5511999999999',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      dateContact: '2024-11-11T11:53:09.299Z',
      linkContact: 'https://example.com',
      listContact: 'Follow-Up',
      textContact: 'Olá!',
      numberContact: '42',
      checkboxContact: false,
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Rio de Janeiro',
      country: 'Brasil',
      description: 'Apaixonada por design e experiência do usuário.',
      companyName: 'Sendd',
      countryCode: 'BR',
      socialProfiles: {
        github: 'mariana-design',
        twitter: 'mari_designs',
        facebook: 'mariana.souza',
        linkedin: 'mariana-souza',
        instagram: 'mariana.design',
      },
    },
    availabilityStatus: 'offline',
    email: 'mariana.souza@sendd.com',
    id: 21,
    name: 'Mariana Souza',
    phoneNumber: '+5521999999999',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      dateContact: '2024-10-05T10:12:34.567Z',
      linkContact: 'https://designbr.com',
      listContact: 'Prospects',
      textContact: 'Ansiosa para conectar!',
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Belo Horizonte',
      country: 'Brasil',
      description: 'Programador e entusiasta de tecnologia.',
      companyName: 'Sendd',
      countryCode: 'BR',
      socialProfiles: {
        github: 'joao-tech',
        twitter: 'joao_code',
        facebook: 'joao.mendes',
        linkedin: 'joao-mendes',
        instagram: 'joao.coder',
      },
    },
    availabilityStatus: 'offline',
    email: 'joao.mendes@sendd.com',
    id: 20,
    name: 'João Mendes',
    phoneNumber: '+5531999999999',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      textContact: 'Vamos colaborar!',
      checkboxContact: true,
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
  {
    additionalAttributes: {
      city: 'Curitiba',
      country: 'Brasil',
      description: 'Especialista em marketing digital e growth hacking.',
      companyName: 'Sendd',
      countryCode: 'BR',
      socialProfiles: {
        github: 'fernanda-marketing',
        twitter: 'fernanda_growth',
        facebook: 'fernanda.lima',
        linkedin: 'fernanda-lima',
        instagram: 'fernanda.growth',
      },
    },
    availabilityStatus: 'offline',
    email: 'fernanda.lima@sendd.com',
    id: 19,
    name: 'Fernanda Lima',
    phoneNumber: '+5541999999999',
    identifier: null,
    thumbnail: '',
    customAttributes: {
      textContact: 'Vamos impulsionar resultados!',
    },
    lastActivityAt: 1712123233,
    createdAt: 1712123233,
  },
];
